var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "d-flex ga-4" }, [
    _c("img", {
      staticClass: "doctor-img rounded-circle",
      attrs: { src: _vm.imgSrc, alt: "/", width: "56px", height: "56px" },
    }),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("div", { staticClass: "text--text text-subtitle-1" }, [
          _vm._v("\n      " + _vm._s(_vm.fio) + "\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text--text text-body-2" }, [
          _vm._v("\n      " + _vm._s(_vm.workplace) + "\n    "),
        ]),
        _vm._v(" "),
        _c(_setup.AdminButton, {
          staticClass: "mt-2",
          attrs: {
            text: "править",
            link: _setup.reverseFull({
              name: "admin:info_review_change",
              args: [_vm.lpuReviewId],
            }),
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }